var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('standard-button',{staticClass:"button--icon",class:_vm.warningClass,attrs:{"disabled":_vm.disabled,"buttonClasses":_vm.buttonClasses}},[_c('i',{staticClass:"material-icons",class:_vm.iconClasses},[_vm._v(_vm._s(_vm.iconName))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }